import { makeStyles } from '@material-ui/core/styles';

const MIN_HEIGHT = 260;

export const useCardContentStyles = makeStyles(
  theme => ({
    cardContent: {
      padding: `${theme.spacing(3, 0)} !important`
    },
    cardContentWithMinHeight: {
      minHeight: MIN_HEIGHT
    },
    cardPaddingBottom: {
      padding: `${theme.spacing(0, 0, 3)} !important`
    },
    noPadding: {
      padding: '0 !important'
    }
  }),
  { name: 'MuiCardContent' }
);
